import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormattedCurrency } from '../../../components/formatted-currency';

import LabeledRow from '../../../fulfillment-planner/labeled-row';
import messages from '../../../fulfillment-planner/labeled-row/messages';
import { CurrencyPropType } from '../../../prop-types/currency';

import style from './style.module.less';

const renderRateAmount = (rate) => {
  if (rate) {
    return <FormattedCurrency currencyCode={rate.code} value={rate.value} />;
  }
  return <span>- -</span>;
};

const Rate = ({ rate }) => (
  <LabeledRow className={style.row} label={<FormattedMessage {...messages.rate} />} labelClassName={style.label}>
    <span className={style.info}>{renderRateAmount(rate)}</span>
  </LabeledRow>
);

Rate.propTypes = {
  rate: CurrencyPropType,
};

export default Rate;
